<script>
import { Validator, } from "@/plugins/validator";
import { nokMetaFields as metaFields } from "./metaFields";

export default {
    name: "NextOfKinModal",

    data() {

        return {
            errors: [],
        };
    },

    props: {

        showModal: Boolean,
        patientNOK: Object,
    },

    methods: {

        saveData() {

            (new Validator(this.patientNOK, metaFields).validate()).then(() => {
                this.$root.loading = true;
                this.$http.post(`PatientRegistration/PatientNextofKinsDetails`, this.patientNOK).then(response => {
                    this.errors = [];
                    this.$root.loading = false;
                    window.Swal.fire({ text: response.data, type: 'success', showCancelButton: false });
                    this.$emit('refresh');
                    this.$emit('closeModal');
                }).catch(() => {
                    this.$root.loading = false;
                });
            }).catch(errors => {
                this.errors = errors;
            });
        },
    }
}
</script>
<template>
<tail-modal :show="showModal" dimension="sm:11/12 md:w-1/2">
  <template v-slot:title>
    <h5 class="font-bold text-base">Next Of Kin</h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-wrap">
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-name" class="label-control">Name:</label>
            <input type="text" v-model.trim="patientNOK.name" id="grid-name" class="input-sm input-control text-tiny">
            <p class="form-text-error" v-if="errors.filter(error => error.field == 'name').length">
                {{ errors.filter(error => error.field == 'name')[0].message }}</p>
        </div>
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-relationship" class="label-control">Relationship:</label>
            <input type="text" v-model.trim="patientNOK.relationship" id="grid-relationship" class="input-sm input-control text-tiny">
            <p class="form-text-error" v-if="errors.filter(error => error.field == 'relationship').length">
                {{ errors.filter(error => error.field == 'relationship')[0].message }}</p>
        </div>
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-telephone" class="label-control">Telephone:</label>
            <input type="text" v-model.trim="patientNOK.telephone" id="grid-telephone" class="input-sm input-control text-tiny">
            <p class="form-text-error" v-if="errors.filter(error => error.field == 'telephone').length">
                {{ errors.filter(error => error.field == 'telephone')[0].message }}</p>
        </div>
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-id-next-of-kin" class="label-control">ID:</label>
            <input type="text" v-model.trim="patientNOK.nationalid" id="grid-id-next-of-kin" class="input-sm input-control text-tiny">
            <p class="form-text-error" v-if="errors.filter(error => error.field == 'nationalid').length">
                {{ errors.filter(error => error.field == 'nationalid')[0].message }}</p>
        </div>
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-occupation-next-of-kin" class="label-control">Occupation:</label>
            <input type="text" v-model.trim="patientNOK.occupation" id="grid-occupation-next-of-kin" class="input-sm input-control text-tiny">
        </div>
        <div class="md:w-1/3 sm:w-full p-tiny">
            <label for="grid-address-next-of-kin" class="label-control">Address:</label>
            <input type="text" v-model.trim="patientNOK.address" id="grid-address-next-of-kin" class="input-sm input-control text-tiny">
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-sm mr-4" @click="$emit('closeModal')"><i class="fa fa-times"></i> Cancel</button>
    <button class="btn-primary btn-sm text-sm" @click.stop="saveData"><i class="fa fa-save"></i> Save</button>
  </template>
</tail-modal>
</template>